angular.module("Main").directive('systeamCurrency', currency);

function currency() {
    return {
        template: "<span>{{value | currency:vm.currency}}</span>",
        restrict: "EA",
        scope: {value: "="},
        controller: CurrencyController,
        controllerAs: "vm"
    };
}

CurrencyController.$inject = ["CurrencyDataService"];

function CurrencyController(CurrencyDataService) {
    var vm = this;

    CurrencyDataService.loadCurrencyConfiguration().then(function (currency) {
        switch(_.toLower(currency)) {
            case "gbr":
                vm.currency = "£";
                break;
            case "chf":
                vm.currency = "CHF";
                break;
            default:
                vm.currency = "€";
        }
    }).catch(function () {
        vm.currency = "€";
    });
}
